import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-fourflu',
  templateUrl: './fourflu.component.html',
  styleUrls: ['./fourflu.component.scss']
})
export class FourfluComponent implements OnInit {

  exposition: CardContent = {
    title: '4Flu',
    subtitle: 'Modelling four influenza strains and vaccines',
    image_source: 'assets/images/4Flu-Sim.PNG',
    sections: [`
      <p>Daniel Molnar, Anastassia Anastassopoulou, Barbara Poulsen Nautrup, Ruprecht Schmidt-Ott,
        Martin Eichner, Markus Schwehm, Gael Dos Santos, Bernhard Ultsch, Rafik Bekkat-Berkani, 
        Alfred von Krempelhuber, Ilse Van Vlaenderen, Laure-Anne Van Bellinghen: 
        <i>Cost-utility analysis of increasing uptake of universal seasonal quadrivalent influenza 
          vaccine (QIV) in children aged 6 months and older in Germany.</i> 
        Human Vaccines & Immunotherapeutics Vol. 18, No. 5 (2022)</p>
      <p>Rui Cai, Laetitia Gerlier, Martin Eichner, Markus Schwehm, Sankarasubramanian Rajaram, 
        Joaquin MouldQuevedo, Mark Lamotte: 
        <i>Cost-effectiveness of the cell-based quadrivalent versus the standard egg-based
          quadrivalent influenza vaccine in Germany.</i> 
        Journal of Medical Economics Bd. 24, H. 1, S. 490-501 (2021)</p>
      <p>Rui Cai, Martin Eichner, Markus Schwehm, Sankarasubramanian Rajaram, Joaquin Quevedo, 
        Mark Lamotte: 
        <i>Cost-Effectiveness of the CELL-Based Quadrivalent Versus the Standard Egg-Based
          Quadrivalent Influenza Vaccine in Germany.</i>
        Value in Health Vol. 23, Supplement 2, S549 (2020)</p>
      <p>Rui Cai, Markus Schwehm, Joaquin Quevedo: 
        <i>Budget IMPACT Analysis of the CELL-Based Quadrivalent Influenza Vaccine in the 
          German Population Using a Dynamic Transmission MODEL Approach.</i> 
        Value in Health 23: S721 (2020)</p>
      <p>Ruprecht Schmidt-Ott, Daniel Molnar, Anastassia Anastassopoulou, Emad Yanni, 
        Claudia Krumm, Rafik Bekkat-Berkani, Gaël Dos Santos, Philipp Henneke, Markus Knuf, 
        Markus Schwehm, Martin Eichner:
        <i>Assessing direct and indirect effects of pediatric influenza vaccination in Germany 
          by individualbased simulations.</i>
        Human Vaccines & Immunotherapeutics 16(8) (2019)</p>
      <p>Shinya Tsuzuki, Markus Schwehm, Martin Eichner: 
        <i>Simulation studies to assess the long-term effects of Japan's change from trivalent 
          to quadrivalent influenza vaccination.</i> 
        Vaccine, Bd. 36, H. 5, S. 624-630 (2018)</p>
      `]
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients / Partners</h4>GlaxoSmithKline, Sequirus GmbH, Epimos',
      '<h4>Methods</h4>Stochastic Individual-based Modelling',
      '<h4>Technology / Skills</h4>Java, Swing, DES',
      '<h4>Term</h4>2011 - 2015',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
